/**
 * Artikelarten: normaler Artikel, Elternartikel einer Variantenfamilie,
 * Set-Artikel mit Stueckliste.
 *
 * Varianten sind keine eigene Art - eine Variante ist ein normaler Artikel
 * (oder ein Set) mit gesetztem "Variante von". Der Elternartikel ist nur
 * die Klammer: kein Bestand, kein Preis, nicht im Beleg waehlbar.
 */
export const ITEM_KINDS = [
    { value: 'standard', label: 'Artikel' },
    { value: 'parent', label: 'Elternartikel (Variantenfamilie)' },
    { value: 'set', label: 'Set-Artikel (Stückliste)' },
];
export function itemKindLabel(kind) {
    return ITEM_KINDS.find((entry) => entry.value === kind)?.label ?? kind;
}
/**
 * Einstand, mit dem Rohertrag und Set-Summen rechnen: der gleitende
 * Durchschnittspreis, solange es einen gibt. Ohne Wareneingang (Anfangs-
 * bestand, Korrektur ohne Preis, nachgetragener Einkaufspreis) ist der
 * Durchschnitt 0 - dann gilt der Einkaufspreis aus dem Stamm.
 */
export function effectiveCost(item) {
    return item.averageCost > 0 ? item.averageCost : item.purchasePrice;
}
/** Merkmalswerte einer Variante als Text: "Farbe rot · Länge 50 m". */
export function variantAttributesText(attributes) {
    return Object.entries(attributes ?? {})
        .filter(([, value]) => value.trim() !== '')
        .map(([name, value]) => `${name} ${value}`)
        .join(' · ');
}
//# sourceMappingURL=items.js.map